import * as React from 'react';
import { Toast } from 'antd-mobile';

import TitleBox from './titleBox';
import { formatDate, Utils } from '@/utils/app';

import './index.less';

const arrow = 'https://diy-assets.msstatic.com/game-release/arrow.png';

const { useState } = React;
const { validURL, isArd, handleClickInfoRep } = Utils;

function GameDescInfo(props: any) {
  const [isOpen, setOpen] = useState(true);
  const [isHide, setHide] = useState(true);
  const { gameBaseInfo = {}, gameResourceInfo } = props;
  const { gameLanguages, gamePublisher, publishTime, gameScreenshots, gameIntro, isHorizontalScreen} = gameBaseInfo;
  const { adrVersion, iosVersion, privacyPolicy, apkPermission } = gameResourceInfo;

  const getRep = (obj: any) => {
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: obj?.area,
    };
    handleClickInfoRep(newObj);
  };

  const isToday = (str: any) => {
    if (new Date(str).toDateString() == new Date().toDateString()) {
      return '今天';
    } else {
      return formatDate(str, 'yyyy-MM-dd');
    }
  };

  const getVersion = () => {
    let str = '';
    if (isArd()) {
      str = adrVersion;
    } else {
      str = iosVersion;
    }
    return `${str}(${isToday(publishTime * 1000)}更新)`;
  };

  const descTitleBoxProps = {
    title: '游戏介绍',
    more: null,
    jumpMore: () => void 0,
  };
  const infoTitleBoxProps = {
    title: '游戏信息',
    more: null,
    jumpMore: () => void 0,
  };

  const getMoreImg = () => {
    if (!gameScreenshots) return null;
    return (gameScreenshots || '').split(',').map((item: any, i: number) => <img className={`${isHorizontalScreen == 2 ? 'horizontal': ''}`} src={item} alt='' key={i} />);
  };

  const handlePrivacyPolicyKing = () => {
    getRep({ area: 'game-trends' });
    if (!privacyPolicy) {
      return Toast.show({ content: '开发者正在努力完善中...' });
    }
    if (validURL(privacyPolicy)) {
      setTimeout(() => {
        window.location.href = privacyPolicy
      }, 500);
    }
  };
  const handleGameJurisdictionKing = () => {
    getRep({ area: 'game-trends' });
    if (!apkPermission) {
      return Toast.show({ content: '请在游戏上线时查看游戏权限' });
    }
    setHide(false);
  };

  const htmlDecode = () => {
    if (!apkPermission) return '[]';
    // 1.首先动态创建一个容器标签元素，如DIV
    let temp: any = document.createElement('div');
    // 2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
    temp.innerHTML = apkPermission;
    // 3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
    const output = temp.innerText || temp.textContent;
    temp = null;
    return output;
  };

  const Popup = () => {
    // eslint-disable-next-line no-eval
    const list = JSON.parse(htmlDecode());
    const boxList = (list || []).reduce((prev: any, item: any, i: number) => {
      if (item && (item.permissionCN || item.permissionDesc)) {
        prev.push(
          <div className={`permission-wrapper  ${i != apkPermission.length - 1 ? 'border' : ''}`} key={`${item.permissionEN}_${i}`}>
            <p className='permission-key'>{item.permissionCN}</p>
            <p className='permission-value'>{item.permissionDesc}</p>
          </div>,
        );
      }
      return prev;
    }, []);

    return (
      <div className={`popup-apk-permission ${isHide ? 'hide' : ''}`}>
        <div className='popup-apk-permission-content'>
          <h4>该应用需要访问以下权限</h4>
          <div className='popup-apk-permission-box'>
            <div className='permission-dialog'>{boxList}</div>
          </div>
          <div className='popup-but-clone' onClick={() => setHide(true)}>
						×
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='more-img-warper'>
      <div className='more-img-w'>
        <div className='img-w-w'>{getMoreImg()}</div>
      </div>
      <TitleBox {...descTitleBoxProps} />
      <div className={`desc-w ${isOpen ? '' : 'active'}`}>
        {gameIntro}
        <span
          className={`d-w-footer ${gameIntro.length < 100 ? 'back':''}`}
          onClick={() => {
            setOpen(!isOpen);
            getRep({ area: 'game-trends' });
          }}>
          {isOpen ? '展开' : '收起'} <img src={arrow} className={`img-arrow ${isOpen ? '' : 'active'}`} alt='' />
        </span>
      </div>
      <TitleBox {...infoTitleBoxProps} />
      <div className='info-w'>
        <ul className='i-w-ul'>
          <li className='i-w-u-li'>
            <div className='u-l-title'>游戏版本</div>
            <div className='u-l-value'>版本{getVersion()}</div>
          </li>
          <li className='i-w-u-li'>
            <div className='u-l-title'>厂商</div>
            <div className='u-l-value'>{gamePublisher}</div>
          </li>
          <li className='i-w-u-li'>
            <div className='u-l-title'>语言</div>
            <div className='u-l-value'>{gameLanguages}</div>
          </li>
        </ul>
      </div>
      <span onClick={handleGameJurisdictionKing} className='span-a-c'>
				游戏权限 {'>'}
      </span>
      <span onClick={handlePrivacyPolicyKing} className='span-a-c'>
				隐私协议 {'>'}
      </span>
      <Popup />
    </div>
  );
}

export default GameDescInfo;
